<template>
  <div class="ace-container">
    <!-- 官方文档中使用id，这里禁止使用，在后期打包后容易出现问题，使用 ref 或者 DOM 就行 -->
    <div class="ace-editor" ref="ace"></div>
  </div>
</template>

<script>
import ace from 'ace-builds';
/* 启用此行后webpack打包回生成很多动态加载的js文件，不便于部署，故禁用！！
     特别提示：禁用此行后，需要调用ace.config.set('basePath', 'path...')指定动态js加载URL！！
   */
// import 'ace-builds/webpack-resolver'

// import 'ace-builds/src-min-noconflict/theme-monokai' // 默认设置的主题
import 'ace-builds/src-min-noconflict/theme-sqlserver'; // 新设主题
import 'ace-builds/src-min-noconflict/mode-javascript'; // 默认设置的语言模式
import 'ace-builds/src-min-noconflict/mode-json'; //
import 'ace-builds/src-min-noconflict/mode-css'; //
import 'ace-builds/src-min-noconflict/ext-language_tools';
import { ACE_BASE_PATH } from '@/utils/config';

export default {
  data() {
    return {
      aceEditor: null,
      codeValue: this.modelValue,
      modePath: 'ace/mode/javascript', // 同上
      themePath: 'ace/theme/sqlserver', // 不导入 webpack-resolver，该模块路径会报错
    };
  },
  emits: ['update:modelValue'],
  methods: {
    addAutoCompletion(ace) {
      let acData = [
        { caption: 'getWidgetRef', meta: 'VForm API', score: 1, value: 'getWidgetRef()' },
        { caption: 'getFormRef', meta: 'VForm API', score: 1, value: 'getFormRef()' },
        { caption: 'getParentFormRef', meta: 'VForm API', score: 1, value: 'getParentFormRef()' },
        // TODO: 待补充！！
      ];
      let langTools = ace.require('ace/ext/language_tools');
      langTools.addCompleter({
        getCompletions: function (editor, session, pos, prefix, callback) {
          if (prefix.length === 0) {
            return callback(null, []);
          } else {
            return callback(null, acData);
          }
        },
      });
    },

    getEditorAnnotations() {
      return this.aceEditor.getSession().getAnnotations();
    },

    setCssMode() {
      this.aceEditor.getSession().setMode('ace/mode/css');
    },

    setJsonMode() {
      this.aceEditor.getSession().setMode('ace/mode/json');
    },

    setValue(newValue) {
      this.aceEditor.getSession().setValue(newValue);
    },
  },
  mounted() {
    // ace.config.set('basePath', 'https://ks3-cn-beijing.ksyun.com/vform2021/ace')
    ace.config.set('basePath', ACE_BASE_PATH);

    this.addAutoCompletion(ace); // 添加自定义代码提示！！

    this.aceEditor = ace.edit(this.$refs.ace, {
      fontSize: 12, // 编辑器内字体大小
      highlightActiveLine: true,
      maxLines: 20, // 最大行数，超过会自动出现滚动条
      minLines: 5, // 最小行数，还未到最大行数时，编辑器会自动伸缩大小
      mode: this.modePath, // 默认设置的语言模式
      readOnly: this.readonly,
      tabSize: 2, // 制表符设置为2个空格大小
      theme: this.themePath, // 默认设置的主题
      value: this.codeValue,
    });

    this.aceEditor.setOptions({
      enableBasicAutocompletion: true,
      enableLiveAutocompletion: true, // 设置自动提示
      enableSnippets: true, // 设置代码片段提示
    });

    if (this.mode === 'json') {
      this.setJsonMode();
    } else if (this.mode === 'css') {
      this.setCssMode();
    }

    if (!this.userWorker) {
      this.aceEditor.getSession().setUseWorker(false);
    }

    // 编辑时同步数据
    this.aceEditor.getSession().on('change', ev => {
      this.$emit('update:modelValue', this.aceEditor.getValue());
    });
  },
  name: 'CodeEditor',
  props: {
    mode: {
      default: 'javascript',
      type: String,
    },
    modelValue: {
      type: String,
      // required: true
    },
    readonly: {
      default: false,
      type: Boolean,
    },
    userWorker: {
      default: true,
      // 是否开启语法检查，默认开启
      type: Boolean,
    },
  },
  watch: {
    //
  },
};
</script>

<style lang="scss" scoped>
.ace-editor {
  min-height: 300px;
}
</style>
